import { Checkbox, FormControlLabel, Grid, TextField } from '@mui/material'
import React, { useState } from 'react'
import { SaveIconButton } from '../../../components/Buttons/SaveIcon'
import { Courier } from '../../../interfaces/Courier'
import { ApiConfig } from '../../../config/api'
import axios from 'axios'
import { useApi } from '../../../hooks/useApi'
import { Status } from '../../../hooks/useFetchState'

interface UpdateCourierProps {
  courier: Courier
  getServices: () => void
  handleSnackbar: (msg: string | undefined, status: boolean) => void
}

const putCourier = (courierId: number, dto: Partial<Courier>) => {
  const url = new URL(`${ApiConfig.CourierApi}/${courierId}`)

  return axios.put(url.toString(), dto)
}

export const UpdateCourier: React.FC<UpdateCourierProps> = ({
  courier,
  getServices,
  handleSnackbar
}) => {
  const [courierState, setCourierState] = useState<Partial<Courier>>(courier)

  const { state, callApi } = useApi()

  const requestUpdateCourier = () => {
    callApi(putCourier(courier.courierId, courierState))
      .then(() => getServices())
      .catch((err) => handleSnackbar(err, false))
  }

  return (
    <Grid container spacing={2} direction={'row'}>
      <Grid item xs={9}>
        <TextField
          disabled={state.status === Status.Loading}
          variant='outlined'
          fullWidth
          name='name'
          value={courierState.name}
          onChange={(e) =>
            setCourierState((prev) => ({ ...prev, name: e.target.value }))
          }
          label='Nombre de transportista'
        />
      </Grid>
      <Grid item xs={2}>
        <FormControlLabel
          control={
            <Checkbox
              name='hasPriorization'
              checked={!!courierState.hasPriorization}
              size='medium'
              color='primary'
              onChange={(_e, checked) =>
                setCourierState((prev) => ({
                  ...prev,
                  hasPriorization: checked
                }))
              }
            />
          }
          label='Priorización'
        />
      </Grid>
      <Grid item xs={1}>
        <SaveIconButton
          fontSize='small'
          onClick={requestUpdateCourier}
          isLoading={state.status === Status.Loading}
        />
      </Grid>
    </Grid>
  )
}
